import { motion } from "framer-motion";

export default function Navbar({ onExplore }) {
  return (
    <motion.header
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.2, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50"
      data-testid="navbar"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-5 md:px-10">
        <a
          href="/"
          data-testid="navbar-brand"
          className="flex items-center gap-3"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0 });
          }}
        >
          <svg width="22" height="22" viewBox="0 0 64 64" aria-hidden="true">
            <path
              d="M32 6 L39 25 L58 32 L39 39 L32 58 L25 39 L6 32 L25 25 Z"
              fill="#D4AF37"
            />
          </svg>
        </a>
        <nav className="flex items-center gap-7">
          <button
            onClick={onExplore}
            data-testid="nav-explore-button"
            className="text-xs uppercase tracking-[0.25em] text-zinc-300 transition-colors hover:text-gold"
          >
            Nos maisons
          </button>
        </nav>
      </div>
    </motion.header>
  );
}
